<template>
  <div class="borrowMoneylist">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onSearch"
    >
      <template v-slot:left>
        <el-button type="primary" @click="onHandleAdd">新增</el-button>
      </template>
    </Filtersearch>
    <!-- 表单搜索 end -->

    <!-- 列表 start -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column label="品牌名" prop="brand" align="center">
        </el-table-column>
        <el-table-column label="推荐语" prop="recommend" align="center">
        </el-table-column>
        <el-table-column label="最高可借额度" prop="loan_amount" align="center">
        </el-table-column>
        <el-table-column label="最高年化利率" prop="loan_rate" align="center">
             <template slot-scope="scope">
           {{ scope.row.loan_rate }}%
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sort_field" align="center">
        </el-table-column>
        <el-table-column label="位置" prop="type" align="center">
        </el-table-column>
        <el-table-column prop="status" align="center" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status === 1"
              >启用</el-tag
            >
            <el-tag type="warning" v-if="scope.row.status === -1"
              >停用</el-tag
            >
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            <el-button type="text" @click="handleDel(scope.row)"
            v-if="scope.row.status != 1"
              >删除</el-button
            >
            <el-button type="text" @click="gopath(scope.row)"
              >查看数据</el-button
            >
          </template>
        </el-table-column>
        <!-- 列表操作栏 end -->
      </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->

    <el-dialog
      :title="title"
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      width="70%"
      class="dialog"
      center
    >
      <div class="contents" style="padding-top: 20px;">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="160px"
          class="demo-ruleForm"
        >
          <el-form-item label="品牌名" prop="brand">
            <div>
              <el-input
                v-model="ruleForm.brand"
                placeholder="请输入品牌名"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="最高可借额度" prop="loan_amount">
            <div>
              <el-input
                v-model="ruleForm.loan_amount"
                placeholder="请输入最高可借额度"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="最高年化利率" prop="loan_rate">
            <div>
              <el-input
                v-model="ruleForm.loan_rate"
                placeholder="请输入最高年化利率"
                clearable
              >
              <template slot="append">%</template>
            </el-input>
            </div>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-select
              v-model="ruleForm.type"
              placeholder="请选择类型"
              style="width: 200px"
            >
              <el-option label="banner" :value="1"></el-option>
              <el-option label="列表" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐语" prop="recommend">
            <div>
              <el-input
                v-model="ruleForm.recommend"
                placeholder="请输入推荐语"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="上传 logo" prop="logo">
            <el-upload
              action="#"
              :class="{ hide: logo.length == 1 }"
              :file-list="logo"
              list-type="picture-card"
              :http-request="
                (file) => {
                  return uploadFile(file, 'logo');
                }
              "
              :before-remove="
                (file, fileList) => {
                  return deleteFile(file, fileList, 'logo');
                }
              "
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="排序" prop="sort_field">
            <div>
              <el-input
                v-model="ruleForm.sort_field"
                placeholder="请输入排序"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="跳转类型" prop="external_link_type">
            <el-select
              v-model="ruleForm.external_link_type"
              placeholder="请选择跳转类型"
              style="width: 200px"
            >
              <el-option label="小程序" :value="1"></el-option>
              <el-option label="h5" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跳转链接" prop="external_link">
            <div>
              <el-input
                v-model="ruleForm.external_link"
                placeholder="请输入跳转链接"
                clearable
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="appid" prop="app_id" v-if="ruleForm.external_link_type==1">
            <div>
              <el-input
                v-model="ruleForm.app_id"
                placeholder="请输入appid"
                clearable
              ></el-input>
            </div>
          </el-form-item>
           <el-form-item label="状态" prop="status">
            <el-radio-group
              v-model="ruleForm.status"
             
            >
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="-1">停用</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="btndisabled" @click="addCategories">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import cloneDeep from "lodash/cloneDeep";
import throttle from "lodash/throttle";
export default {
  name: "CityStoreManage",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "select",
          name: "状态",
          clearable: true,
          model: "status",
          placeholder: "请选择状态",
          label: "name",
          value: "id",
          selectoption: [
            { id: "-1", name: "停用" },
            { id: "1", name: "启用" },
          ],
        },
      ],
      loading: false,
      centerDialogVisible: false,
      title: "添加",
      logo: [],
      //列表页面不同功能参数
      ruleForm: {
        id: "",
        brand: "",
        loan_amount: "",
        loan_rate: "",
        status: 1,
        type: "",
        recommend: "",
        logo: "",
        sort_field: "",
        external_link_type: "",
        external_link: "",
        app_id: "",
      },
      rules: {
        // kv: [{ required: true, message: "请上传图片", trigger: "blur" }],
        logo: [{ required: true, message: "请上传显示图", trigger: "change" }],
        brand: [{ required: true, message: "请输入品牌名", trigger: "blur" }],
        loan_amount: [{ required: true, message: "请输入最高可借额度", trigger: "blur" }],
        loan_rate: [{ required: true, message: "请输入最高年化利率", trigger: "blur" }],
        recommend: [{ required: true, message: "请输入推荐语", trigger: "blur" }],
        app_id: [{ required: true, message: "请输入appid", trigger: "blur" }],
        external_link: [{ required: true, message: "请输入跳转链接", trigger: "blur" }],

        type: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
       


        sort_field: [{ required: true, message: "请输入排序", trigger: "blur" }],

        external_link_type: [
          { required: true, message: "请选择跳转类型", trigger: "change" },
        ],
        status: [
          { required: true, message: "请选择状态", trigger: "change" },
        ],
      },
      formData: {
        brand: "", //
        status: "", // 禁用状态
        type: "", //

        page: 1,
        pageSize: 100,
      }, // 表单参数
      formDataClone: {}, // 表单参数拷贝，用于重置
      tableData: [], // 城市仓列表
      total: 0,
      btndisabled: false,
    };
  },
  mounted() {
    this.onInitData();
  },
  methods: {
    /**
     * 新增/编辑一级品类
     */
    addCategories(){
      console.log(this.ruleForm);
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
            this.btndisabled=true;
            this.$api.borrowMoney
            .buildData(this.ruleForm)
            .then((res) => {
              console.log(res, "停用或者开启");
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.btndisabled=false;
              this.centerDialogVisible=false;
              Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
              this.ajaxGetTableList();
            }).catch(err=>{
                 this.btndisabled=false;
            });
        }
      });
    },
    deleteFile(file, fileList, name) {
      this[name] = fileList;
      this.ruleForm[name] = fileList;
    },
    uploadFile(options, name) {
      // 拿到 file
      let file = options.file;
      let date = new Date().getTime();
      console.log(file, "文件");
      var event = event || window.event;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        this.uploadImage(e.target.result, name);
      };
    },
    uploadImage(img, name) {
      this.$api.general.uploadImage({ file_data: img }).then((res) => {
        this[name] = [{ url: res.data }];
        this.ruleForm[name] = res.data;
      });
    },
    onHandleAdd() {
      Object.assign(this.$data.ruleForm, this.$options.data().ruleForm);
      this.logo=[];
      this.title = "添加";
      this.centerDialogVisible = true;
    },
    edit(e){
this.ruleForm=JSON.parse(JSON.stringify(e));
this.logo=[{url:e.logo}];
  this.title = "编辑";
      this.centerDialogVisible = true;
    },
    handleDel(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$api.borrowMoney
            .setDelLine({
              loanAdId: row.id,
            })
            .then((res) => {
              console.log(res, "停用或者开启");
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.ajaxGetTableList();
            });
        })
        .catch(() => {});
    },
    gopath(e) {
      this.$router.push({
        path: "/borrowMoneyClickList",
        query: {
          id: e.id,
        },
      });
    },
    ajaxGetTableList() {
      this.loading = true;
      this.$api.borrowMoney.categorieslist(this.formData).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    /**
     * 初始化
     */
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.ajaxGetTableList();
    },

    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.ajaxGetTableList();
    },
    /**
     * 搜索表单
     */
    onSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.ajaxGetTableList();
    },

    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.ajaxGetTableList();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.ajaxGetTableList();
    },
  },
};
</script>
<style lang="scss">
.borrowMoneylist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .table-wrap {
    flex-grow: 1;
    overflow-y: hidden;
    .text-btn {
      color: $theme-color;
      cursor: pointer;
    }
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
